import type { ResourceInput } from '@fullcalendar/resource'
import type { InjectionKey, Ref, WritableComputedRef } from 'vue'
import type { Client } from './types/client.type'
import type { Project } from './types/project.type'
import type { ScheduleView } from './types/schedule.type'
import type { CalendarEventDurations, CalendarEventInput, CalendarView } from '~/types/calendar.type'

export const calendarDateInjectionKey = Symbol('calendarDate') as InjectionKey<Ref<Date>>
export const calendarViewInjectionKey = Symbol('calendarView') as InjectionKey<Ref<CalendarView>>
export const eventDurationsInjectionKey = Symbol('eventDurations') as InjectionKey<Ref<CalendarEventDurations>>
export const calendarProjectInjectionKey = Symbol('calendarProject') as InjectionKey<Project<'withClient' | 'withLeads'>>
export const calendarClientInjectionKey = Symbol('calendarClient') as InjectionKey<Client>
export const vacationEventsInjectionKey = Symbol('vacationEvents') as InjectionKey<Ref<CalendarEventInput[]>>

export const schedulingScheduleViewInjectionKey = Symbol('schedulingScheduleView') as InjectionKey<WritableComputedRef<ScheduleView>>
export const schedulingScheduleResourcesInjectionKey = Symbol('schedulingResources') as InjectionKey<ComputedRef<ResourceInput[]>>

export const tableActionsIsInsideDropdownInjectionKey = Symbol('tableActionsIsInsideDropdown') as InjectionKey<true>
